export class SendOTPRequest {
  public channel: string;
  public userContact: string;
  public maskedUserContact: string;
}

export class VerifyOTPRequest {
  public userContact: string;
  public accessCode: string;
  public channel: string;
  public sessionId: string;
}

export class SearchContractRequest {
  reCaptchaValue: string;
  searchParameters: SearchParameter[];
}

export class SearchParameter {
  constructor(
    public key: string,
    public value: string) {
  }
}

export class ContractContactDetails {
  phone: string;
  addressLine1: string;
  addressLine2: string;
  country: string;
  city: string;
  state: string;
  zipCode: string;
  smsConsent: boolean;
  primaryEmail: string;
  contractId: string;
  firstName: string;
  lastName: string;
  hasProcessedName: boolean;
}

export enum OtpChannel {
  email,
  sms,
  call
}
